export default __webpack_public_path__ + "static/media/bannerAddGuestRooms.b9943a2e.jpg";